<template>
  <div>
    <v-container fluid>
      <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
        <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
        <v-btn dark text @click="snackbar = false">Close</v-btn>
      </v-snackbar>
      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

        <v-card class="box">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Fetch Transport Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
          <v-row fluid justify="center">
            <v-radio-group v-model="radios" row>
                <v-radio label="All"  @change="learner_transport_fees_installment_details_new = []" value="all"></v-radio>
                <v-radio label="Fetch Cancel Requests" @change="learner_transport_fees_installment_details = []" value="requests"></v-radio>
                <!-- <v-radio label="Change Transport Route" @change="learner_transport_fees_installment_details = []" value="change_route"></v-radio> -->
            </v-radio-group>
        </v-row>
        </v-card>
        <v-card class="box" v-if="radios == 'requests'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Cancel Transport Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
        <v-row justify="center" dense>
           <v-col cols="12" sm="2"></v-col>
          <v-col cols="12" sm="2">
            <!-- <p><v-icon color="error">*</v-icon><b>Academic Year</b></p> -->
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay_fetch"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
            />
          </v-col>
           <v-col col="12" sm="4" md="4">
            <v-btn color="warning" @click="fetchCancelRequest()">Fetch Cancel Requests</v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="box" v-if="radios == 'all'">
        <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Cancel Transport Application</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-row justify="center" dense>
          <v-col cols="12" sm="2">
            <p><b>Academic Year</b><v-icon small class="pb-2 pl-1" color="error">*</v-icon></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="ay"
              :items="ay_list"
              item-text="ay"
              item-value="id"
              label="Academic Year"
              outlined
              persistent-hint
              hint="Please Select Academic Year"
              @change="getInstallmentData()"
            />
          </v-col>
          
          <v-col cols="12" sm="2" v-if="transport_installment_list!=''">
            <p><b>Installment</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="transport_installment"
              :items="transport_installment_list"
              item-text="name"
              item-value="id"
              label="Transport Installment"
              outlined
              persistent-hint
              hint="Please Select Installment"
            />
          </v-col>
          <v-col cols="12" sm="3" v-if="all_learner_list!=''">
            <p><b>Learner</b></p>
            <v-autocomplete
              color="#0F2027"
              dense
              rounded
              required
              v-model="learner"
              :items="all_learner_list"
              item-text="learner"
              item-value="id"
              label="Student"
              outlined
              persistent-hint
              hint="Please Select Student"
            />
          </v-col>
          <v-col col="12" sm="2" md="2" style="align-content: center;" class="mt-2 pl-5">
            <v-btn color="warning" @click="fetch()">Fetch</v-btn>
          </v-col>
        </v-row>
        <!-- //v-if="this.transport_installment && this.transport_status && this.learner"> -->
        
      </v-card>
      <!-- {{tranport_fee_sync}} -->

      <!-- <span v-if="!tranport_fee_sync == true">
      <v-card
        class="box"
        v-if="learner_transport_fees_installment_details.length > 0"
      >
        <v-data-table :headers="headers" :items="learner_transport_fees_installment_details" :search="search" :items-per-page="-1">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false">
              <v-avatar size="35">
                <v-icon
                  class="mr-4 v-icon-size"
                  color="green"
                  @click="editItem(item)"
                  >mdi-application-export</v-icon
                >
              </v-avatar>
            </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
      </span> -->
     
      <!-- <span v-else> -->
        <v-card
        class="box"
        v-if="learner_transport_fees_installment_details.length > 0"
      >
        <v-data-table :headers="headers_2" :items="learner_transport_fees_installment_details" :search="search">
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" background-color="white"  single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false && item.iscancelled==false && item.cancancel== true">
              <v-btn color="warning" @click="confirmCancel(item)">Cancel</v-btn>
            </div>
             <div v-else-if="item.iscancelled==true">
               <b>Already Cancelled...</b>
             </div>
              <div v-else-if="item.cancancel==false">
               <b>Cannot Cancel..Fees Paid</b> 
             </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
           <template v-slot:[`item.sync_amount`]="{ item }">
             <!-- <div v-if="item.sync_amount == 0 ">
               <b>Application Not Approved Yet...</b>
             </div>
             <div v-else> -->
               {{item.sync_amount}}
             <!-- </div> -->
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="confirmCancel_dialog" max-width="500px">
        <v-card>
          <v-card-title class="toolbar">
            Cancel Transport Request
          </v-card-title>
          <br>
          <v-card-text>
            <v-text-field
              v-model="remark"
              label="Enter remark"
              outlined
              dense
            ></v-text-field>

            <v-menu
            v-model="menu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="cancel_date"
              label="Select Date"
              prepend-inner-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
              outlined
              dense
            ></v-text-field>
          </template>

          <v-date-picker
            v-model="cancel_date"
            @input="menu = false"
          ></v-date-picker>
         </v-menu>
          </v-card-text>
          
          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="grey" text @click="confirmCancel_dialog = false">
              Close
            </v-btn>

            <v-btn color="red" text @click="markCancel">
              Confirm Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
       <v-card
        class="box"
        v-if="learner_transport_fees_installment_details_new!=''"
      >
        <v-data-table :headers="headers_2" :items="learner_transport_fees_installment_details_new" :search="search" >
          <template v-slot:top>
            <v-toolbar flat class="toolbar">
              <v-toolbar-title>Cancel Request List</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" background-color="white"  single-line hide-details></v-text-field>
            </v-toolbar>
          </template> 
          <template v-slot:[`item.action`]="{ item }">
            <div v-if="item.is_blocked_for_transport==false && item.iscancelled==false && item.cancancel== true">
              <v-btn color="warning" @click="markCancelRequest(item)">Cancel</v-btn>
            </div>
             <div v-else-if="item.iscancelled==true">
               <b>Already Cancelled...</b>
             </div>
              <div v-else-if="item.cancancel==false">
               <b>Cannot Cancel..Fees Paid</b> 
             </div>
             <div v-else>
              <b>Student Is Blocked For Transport...</b>
            </div>
          </template>
           <template v-slot:[`item.sync_amount`]="{ item }">
             <!-- <div v-if="item.sync_amount == 0 ">
               <b>Application Not Approved Yet...</b>
             </div>
             <div v-else> -->
               {{item.sync_amount}}
             <!-- </div> -->
          </template>
        </v-data-table>
      </v-card>

     <!-- <v-card class="box" v-if="radios == 'change_route'">
     <v-toolbar flat dense class="toolbar">
          <v-toolbar-title>Change Transport Route</v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
        </v-toolbar>
        <br>
         <change-transport-route></change-transport-route>
     </v-card> -->
      <!-- </span> -->
    </v-container>
  </div>
  <!-- /. root div -->
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
// import ChangeTransportRoute from "./ChangeTransportRoute";
export default {
  //  components: {
  //           "change-transport-route": ChangeTransportRoute,
  //       },
  data: () => ({
    radios:null,
    search: "",
    is_final_approved:false,
    loader: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ay_list: [],
    ay: "",
    ay_fetch: "",ay_change:"",
    standard_list: [],
    standard: "",
    transport_status_list: [],
    transport_status: "",
    transport_installment_list: [],
    transport_installment: "",
    all_learner_list: [],
    learner: "",
    learner_transport_fees_installment_details: [],
    learner_transport_fees_installment_details_new:[],
    learner_transport_fees_installment_details_change:[],
    show_approve_transport_card: false,
    child_details: {
      lid: "",
      registration_number: "",
      learner: "",
      standard: "",
      pickup_time: "",
      drop_time: "",
      academicYear: "",
      contact: "",
      resedential_address: "",
      totalfees: "",
      paid_till_now: "",
      applicable_fees: "",
      routestop: "",
      route: "",
      distanceslab: "",
      transport_installment_amount: "",
      transport_installment: "",
      routestop_name: "",
      route_name: "",
    },
    totalfees_approved: "",
    route_stops: [],
    routestop: "",
    routes: [],
    route: "",
    transport_installment_list: [],
    transportinstallment: "",
    transport_status_list: [],
    transportstatus: "",
    approve_remark: "",
    cancel_date: "",
    learnertransportfeesinstallment: "",
    transportApprovalDetails: [],
    show_approve_history_card: false,
    transportApplicationsDetails: [],
    learner_transport_fees_installment_id: "",
    headers: [
      { text: "SR No", value: "srno" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Installment", value: "transportinstallment" },
      { text: "Fees In Rs", value: "amount" },
      { text: "Paid Till Now", value: "paid_till_now" },
      { text: "Your Approval Status", value: "your_status" },
      { text: "Final Approval Status", value: "transportapprovalstatus" },
      { text: "Action", value: "action" },
      { text: "My Approval Status", value: "history" },
    ],
      headers_2: [
      { text: "SR No", value: "srno" },
      { text: "PRN", value: "prn" },
      { text: "Student", value: "name" },
      { text: "Route Stop", value: "route_stop" },
      { text: "Installment", value: "transportinstallment" },///
      { text: "Fees In Rs", value: "sync_amount" },                //learnerTransportFes
      { text: "Paid Till Now", value: "sync_paid_till_now" },
      // { text: "Your Approval Status", value: "your_status" },
      { text: "Application Date", value: "application_date" },
      { text: "Cancellation Request Date", value: "cancellation_request_date" },
      { text: "Cancel Date", value: "cancelled_date" },
      { text: "Action", value: "action" },
      { text: "Reason", value:"reason"}
      // { text: "Unmark", value: "unmark", },
      // { text: "Is Sync", value: "is_transport_sync" },
      // { text: "My Approval Status", value: "history" },
      
    ],
    isLastAuthority:false,
    tranport_fee_sync:false,
    unmark_tranport_fee_sync:false,
    confirmCancel_dialog: false,
    selectedItem: null,
    remark: ""
  }),
  methods: {
    fetchTransportApplications(){
      const data = {
        ay:this.ay_change
      };
      this.overlay = true;
       axios
        .post("/ParentTransport/fetchTransportApplicationsToChangeRoute", data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.learner_transport_fees_installment_details_change =res.data.learner_transport_fees_installment_details;
             this.tranport_fee_sync=res.data.tranport_fee_sync
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetchCancelRequest(){
      const data = {
        ay:this.ay_fetch
      };
      this.overlay = true;
       axios
        .post("/ParentTransport/fetchCancelRequest", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //  this.learner_transport_fees_installment_details_new =res.data.learner_transport_fees_installment_details;
           this.learner_transport_fees_installment_details_new =(res.data.learner_transport_fees_installment_details || []).filter(item => {
            return item.cancancel === false || item.iscancelled === true;
                  });
             this.tranport_fee_sync=res.data.tranport_fee_sync
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    markCancelRequest(item){
      if (!confirm("Are You Sure You Want To Cancel Request...?")) return;
      const data = {
        learner_transport_fees_installment: item.id,
        learner_id: item.learner_id, 
        ay:this.ay
      };
      this.overlay = true;
       axios
        .post("/ParentTransport/markCancel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fetch();
            this.showSnackbar("green", "Cancelled...");
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          this.fetchCancelRequest()
        });
    },
    confirmCancel(item) {
      this.selectedItem = item;
      this.remark = "";
      this.cancel_date = "";
      this.confirmCancel_dialog = true;
    },
    markCancel() {
      if (!this.remark || !this.cancel_date) {
        this.showSnackbar("red", "Please enter remark and date");
        return;
      }

      const item = this.selectedItem;

      const data = {
        learner_transport_fees_installment: item.id,
        learner_id: item.learner_id,
        ay: this.ay,
        remark: this.remark,
        date: this.cancel_date
      };

      this.overlay = true;

      axios
        .post("/ParentTransport/markCancel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.fetch();
            this.showSnackbar("green", "Cancelled successfully...");
            this.confirmCancel_dialog = false;
          } else {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          this.onerror(error);
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    getInstallmentData(){
      this.transport_installment_list=[],
      this.all_learner_list=[],
       this.learner_transport_fees_installment_details =[]
       const data = {
        academicYear: this.ay
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentDataByAy", data)
        .then((res) => {
          if (res.data.flag == "YES") {
             this.transport_installment_list = res.data.transport_installment_list;
            this.all_learner_list = res.data.all_learner_list;
            if(this.transport_installment_list==''){
                this.showSnackbar("red", "Installment List Not Defined For This Academicyear...");    
                return
            }           
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    setValue(installment_name) {
      // // alert("installment_name::"+installment_name)
      // this.totalfees_approved = this.child_details.totalfees;
      // if (installment_name.name != "Yearly") {
      //   this.totalfees_approved = parseFloat(this.child_details.totalfees / 2);
      // } else {
      //   this.totalfees_approved;
      // }
      // return this.totalfees_approved;
      const data = {
        installment: installment_name,
        learner_transport_fees_installment_id:
          this.learner_transport_fees_installment_id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getInstallmentAmount", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.totalfees_approved = res.data.final_amount;
            //  this.show_fees = true
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    getArrovalHistory(item) {
      const data = {
        learnertransportfeesinstallment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/getArrovalHistory", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.transportApprovalDetails = res.data.transportApprovalDetails;
            this.transportApplicationsDetails =
              res.data.transportApplicationsDetails[0];
            this.show_approve_history_card = true;
            // this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    saveApproveStatus() {
      if (!confirm("Are You Sure You Want To Save...?")) return;
      if (this.transportstatus == null || this.transportstatus == "") {
        this.showSnackbar("red", "Please Select Status");
        return;
      }
      const data = {
        learnertransportfeesinstallment: this.learnertransportfeesinstallment,
        transportstatus: this.transportstatus,
        remark: this.approve_remark,
        transportinstallment: this.transportinstallment,
        total_fees: this.totalfees_approved,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/saveApproveStatus", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.show_approve_transport_card = false), this.fetch();
            this.showSnackbar("green", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    editItem(item) {
      this.transportstatus=""
      this.learner_transport_fees_installment_id = item.id;
      const data = {
        learner_transport_fees_installment: item.id,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplicationsDetails", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.child_details.registration_number =res.data.registration_number;
            this.child_details.learner = res.data.learner;
            this.child_details.lid = res.data.lid;
            this.child_details.standard = res.data.standard;
            this.child_details.pickup_time = res.data.pickup_time;
            this.child_details.drop_time = res.data.drop_time;
            this.child_details.academicYear = res.data.academicYear;
            this.child_details.contact = res.data.contact;
            this.child_details.resedential_address =res.data.resedential_address;
            this.route_stops = res.data.route_stops;
            this.routes = res.data.routes;
            this.child_details.totalfees = res.data.totalfees;
            this.child_details.applicable_fees = res.data.applicable_fees;
            this.child_details.paid_till_now = res.data.paid_till_now;
            this.child_details.routestop = res.data.routestop;
            this.child_details.route = res.data.route;
            (this.child_details.distanceslab = res.data.distanceslab),
              (this.routestop = res.data.routestop_id);

            this.child_details.routestop_name = res.data.routestop;
            this.child_details.route_name = res.data.route;
            this.child_details.transport_installment_amount =res.data.transport_installment_amount;
            this.child_details.transport_installment =res.data.transport_installment;

            this.route = res.data.route_id;
            this.transport_installment_list =res.data.transport_installment_list;
            this.transport_status_list = res.data.transport_status_list;
            //this.transportinstallment=res.data.transport_installment_id
            this.learnertransportfeesinstallment =res.data.learnertransportfeesinstallment;
            this.is_final_approved=res.data.is_final_approved
            this.show_approve_transport_card = true;
            // this.learner_transport_fees_installment_details=res.data.learner_transport_fees_installment_details
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    fetch() {
       if(this.transport_installment==''){
          this.showSnackbar("red","Please Select Installment");
            return
      }
      if(this.learner==''){
          this.showSnackbar("red","Please Select Students");
          return
      }
      const data = {
        academicYear: this.ay,
        learner: this.learner,
        transport_status: this.transport_status,
        transport_installment: this.transport_installment,
        standard: this.standard,
      };
      this.overlay = true;
      axios
        .post("/ParentTransport/fetchTransportApplicationsToCancel", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            //this.showSnackbar("green", res.data.snackbar);
            this.learner_transport_fees_installment_details =
              res.data.learner_transport_fees_installment_details;
              this.isLastAuthority=res.data.isLastAuthority,
              this.tranport_fee_sync=res.data.tranport_fee_sync
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    onLoad() {
      axios
        .post("ParentTransport/cancelTransportApplicationHome")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), 
            // (this.ay_fetch = res.data.curreny_ay);
            this.transport_installment_list =
              res.data.transport_installment_list;
           // this.all_learner_list = res.data.all_learner_list;
            this.overlay = false;
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong!!!");
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
  mounted() {
    this.onLoad();
  },
  watch: {},
};
</script>
<style scoped>
</style>